import React, { useEffect, useState } from "react";
import axios from "../../axios";
import { toast } from "react-toastify";
import Loader from "../loader/Loader";

const EditHowToUseVideo = (props) => {
  const [titleAl, setTitleAl] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [titleSr, setTitleSr] = useState("");
  const [video, setVideo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");

  const id = props?.match?.params?.id;

  useEffect(() => {
    axios
      .get(`how-to-use-videos/${id}`)
      .then((res) => {
        const item = res?.data;
        setTitleAl(item?.title_al || item?.title || "");
        setTitleEn(item?.title_en || "");
        setTitleSr(item?.title_sr || "");
        setCurrentVideoUrl(item?.video_url || "");
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error("Something went wrong!");
        console.log(err);
        setIsLoading(false);
      });
  }, [id]);

  const videoChange = (e) => {
    const file = e.target.files[0];
    setVideo(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    // keep legacy "title" mainly for backwards compatibility
    formData.append("title", titleAl || titleEn || titleSr || "");
    formData.append("title_al", titleAl || "");
    formData.append("title_en", titleEn || "");
    formData.append("title_sr", titleSr || "");
    if (video) {
      formData.append("video", video);
    }

    try {
      setIsLoading(true);
      await axios.put(`how-to-use-videos/${id}`, formData);
      toast.success("Video has been updated successfully!");
      window.history.back();
    } catch (err) {
      toast.error("Something went wrong!");
      console.log(err);
      setIsLoading(false);
    }
  };

  const buildVideoSrc = (path) => {
    if (!path) return "";

    return `${process.env.REACT_APP_UPLOADS}${path}`;
  };

  return (
    <div className="privacy_policy p-5 text-left">
      <div className="page-title">
        <h1>Edit How To Use Video</h1>
      </div>
      {isLoading ? (
        <Loader />
      ) : (
        <form onSubmit={handleSubmit}>
          <label>Title Albanian (optional)</label>
          <input
            type="text"
            value={titleAl}
            onChange={(e) => setTitleAl(e.target.value)}
            placeholder="Titulli (AL)"
          />

          <label>Title English (optional)</label>
          <input
            type="text"
            value={titleEn}
            onChange={(e) => setTitleEn(e.target.value)}
            placeholder="Title (EN)"
          />

          <label>Title Serbian (optional)</label>
          <input
            type="text"
            value={titleSr}
            onChange={(e) => setTitleSr(e.target.value)}
            placeholder="Naslov (SR)"
          />

          {currentVideoUrl && (
            <div className="mb-3">
              <label>Current video</label>
              <br />
              <video
                src={buildVideoSrc(currentVideoUrl)}
                width="320"
                controls
              />
            </div>
          )}

          <label>Replace video (optional)</label>
          <input type="file" accept="video/*" onChange={videoChange} />

          <button type="submit">Save</button>
        </form>
      )}
    </div>
  );
};

export default EditHowToUseVideo;

